<template>
    <div
        :class="[
            'p-4 sm:p-6 lg:p-8 border border-taupe-200 rounded-xl bg-white overflow-hidden',
            flush ? '' : 'mt-6',
        ]"
    >
        <div
            v-if="hasTitle"
            :class="[
                '-mx-4 sm:-mx-6 lg:-mx-8 -mt-4 sm:-mt-6 lg:-mt-8 bg-taupe-50 border-b border-taupe-200 px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between',
                showEmpty ? 'mb-0' : 'mb-4 sm:mb-6 lg:mb-8',
            ]"
        >
            <h3
                v-if="!hasTitleSlot"
                class="text-base font-medium text-taupe-800"
            >
                {{ title }}
            </h3>
            <div v-else class="min-w-0">
                <slot name="title" />
            </div>
            <div v-if="hasActions" class="sm:flex-none">
                <slot name="actions" />
            </div>
        </div>
        <div v-if="showFilters || showStandaloneActions" class="sm:flex mb-4">
            <div class="sm:flex-auto w-full">
                <slot v-if="showFilters" name="filters" />
            </div>
            <div
                v-if="!hasTitle && hasActions"
                :class="
                    showFilters
                        ? 'mt-4 sm:mt-0 sm:ml-16 sm:flex-none'
                        : 'sm:flex-none'
                "
            >
                <slot name="actions" />
            </div>
        </div>
        <div>
            <slot v-if="!showEmpty" />
            <div v-else class="p-4">
                <slot name="empty" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'

defineOptions({
    name: 'ZenGrid',
})

const props = defineProps({
    title: {
        type: String,
        required: false,
    },
    flush: {
        type: Boolean,
        required: false,
        default: false,
    },
    empty: {
        type: Boolean,
        required: false,
        default: false,
    },
})

const slots = useSlots()

const hasActions = computed(() => !!slots.actions && slots.actions().length > 0)
const hasFilters = computed(() => !!slots.filters && slots.filters().length > 0)
const hasEmpty = computed(() => !!slots.empty && slots.empty().length > 0)
const hasTitleSlot = computed(() => !!slots.title && slots.title().length > 0)
const hasTitle = computed(() => hasTitleSlot.value || !!props.title)
const showEmpty = computed(() => props.empty && hasEmpty.value)
const showFilters = computed(() => hasFilters.value && !showEmpty.value)
const showStandaloneActions = computed(
    () =>
        !hasTitle.value &&
        hasActions.value &&
        !showFilters.value &&
        !showEmpty.value
)
</script>
